module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Fb-Gb-Hc-Ib-Ja.b602dbfb.png";